// extracted by mini-css-extract-plugin
export var modal = "_ma-0";